import React, { FC } from 'react';

interface ApproximatedConvertedPriceProps {
  formattedPrice?: string;
  style?: {
    marginBottom: string;
  };
}

const ApproximatedConvertedPrice: FC<ApproximatedConvertedPriceProps> = ({ formattedPrice, style }) =>
  formattedPrice ? (
    <>
      <span className="approx-price-text" data-cy="price-approx">
        Approx. {formattedPrice}
      </span>
      <style jsx>
        {`
          .approx-price-text {
            color: #999;
            font-size: 13px !important;
            margin-bottom: ${style?.marginBottom || 0};
            line-height: 1 !important;
          }
        `}
      </style>
    </>
  ) : null;
export default ApproximatedConvertedPrice;
